import {httpClient} from "../../service";
import React, {useEffect, useState} from "react";
import {HttpMethod} from "../../model";
import {TtaSecModel} from '../verifications/VerifyConfigModel';

const T5Detail = (props: any) => {
    const item: TtaSecModel = props.item;
    const [entity, setEntity] = useState<TtaSecModel>(item);
    const [loading, setLoading] = useState<boolean>(false);
    const qrTd = `qrDd${item.idx}`;
    const qrDiv = `qrDiv${item.idx}`;
    const verifyClick = async (e: any) => {
        e.preventDefault();
        console.log(`click button id=${e.target}`);

        const qrId = document.getElementById(qrTd);
        setLoading(true);
        const url = `test/tta5`;
        const options = {
            method: HttpMethod.PUT,
            url,
            body: item
        }
        const act = await httpClient(options);
        setLoading(false);
        if (act.result) {
            setEntity(act.data);
        } else {
            alert(act.errorMsg);
        }
    }

    let resultMsg = '';
    useEffect(() => {
        resultMsg = '검증전';
        if (item.id) {
            console.log(`id:${item.id},difSec=${item.difSec}`);
        }
    }, [item.idx]);

    if (entity.id) {
        if (entity.id > 0) {
            resultMsg = entity.result ? '성공' : `실패<div class="tta-error-msg">${entity.resultMsg}</div>`;
        } else {
            resultMsg = '검증전';
        }
    } else {
        resultMsg = '검증전';
    }
    return (

        <>
            <tr>
                <td>{item.idx}</td>
                <td>{item.shopId}</td>
                <td>{item.shopNm}</td>
           {/*     <td>
                    <Button className="btn-primary" size="sm" onClick={verifyClick} disabled={loading}
                            style={{width: '80px'}}>검증하기</Button>

                </td>*/}
                <td>
                    <div id={qrTd}>{entity.memo}</div>
                </td>
                <td>
                    {entity.startTime}
                </td>
                <td>
                    {entity.endTime}
                </td>
                <td>
                    {entity.difSec}
                </td>
                <td>
                    <div  dangerouslySetInnerHTML={{__html: resultMsg}}></div>
                </td>
            </tr>

        </>
    )
}
export default T5Detail;
